const mapper_options = {
  endpoint: 'reporting/pulse/aggregates',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('pulse_aggregates', mapper_options)
}
